module.exports = __webpack_public_path__ + "img/spwx.ffb32a06.png";